export default __webpack_public_path__ + "static/media/work5.72f92fed.jpg";